<template>
    <div class="block">
        <div
            :class="[backgroundFile2 ? 'roundingImg' : '']"
            :style="{ backgroundImage: `url('${backgroundFile2}')` }"
        >
            <div :class="['patch', displayPatch ? '': 'pacthHidden']">
                <div class="patchSquare">
                    <v-lazy-image
                        class="logo"
                        :src="logoFile"
                        alt=""
                        @load="displayPatch = true"
                    ></v-lazy-image>
                </div>
            </div>
        </div>
        <p class="loadingText">{{ getVerbose('app_loader_text') }}</p>
    </div>
</template>

<script>
import VLazyImage from 'v-lazy-image';
import { mapGetters } from 'vuex';
export default{
    components: {
        VLazyImage
    },

    data (){
        return{
            displayPatch: true,
        };
    },

    computed: {
        ...mapGetters('fundation', [
            'logoFile',
            'backgroundFile2',
            'getVerbose'
        ])
    },

    mounted (){
    },
};
</script>

<style lang="scss">
html, body{
    height: 100%;
    background-color: #212121;
    // background-color: #212121 !important;
}
.block{
    height: 100vh;
    background-color: #212121;
}
.roundingImg{
    height: 100%;
    width: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    clip-path: circle(119px at 50% 50%);
    background-position: center;
}
.patch{
    width: 166px;
    height: 166px;
    background-color: #6b6b6b;
    border-radius: 100px;
    transition: opacity 2s;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;

    .patchSquare{
        width: 115px;
        height: 115px;

        position: absolute;
        /* Ici on utilise pas le translate transform: translate(-50%, -50%); car sinon l'image est un peu flouter*/
        left: calc(50% - 57.5px);
        top: calc(50% - 57.5px);
        z-index: 3;
        // left: 50%;
        // top: 50%;
        // transform: translate(-50%, -50%);
    }
}
.pacthHidden{
    opacity: 0;
}

.logo{
    max-width: 100%;
    max-height: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}


.loadingText{
    font-size: 36px;
    text-align: center;
    color: #ffffff;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: calc(50vh + 160px);
    margin: 31px 0px;

    &:after {
        content: ' .';
        animation: dots 1s steps(5, end) infinite;
    }
@keyframes dots {
  0%, 20% {
    color: rgba(0,0,0,0);
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  40% {
    color: white;
    text-shadow:
      .25em 0 0 rgba(0,0,0,0),
      .5em 0 0 rgba(0,0,0,0);}
  60% {
    text-shadow:
      .25em 0 0 white,
      .5em 0 0 rgba(0,0,0,0);}
  80%, 100% {
    text-shadow:
      .25em 0 0 white,
      .5em 0 0 white;}}
}

</style>
<style type="text/css">

.v-lazy-image{
    opacity: 0;
    transition: opacity 2s;
}
.v-lazy-image-loaded{
    opacity: 1;
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/loading/index.vue